export default [
  {
    path: '/invoices',
    name: 'invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice/index.vue')
  },
  {
    path: '/invoices/create',
    name: 'invoice-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice/create.vue')
  },
  {
    path: '/invoices/create-for-student-no-enrollments',
    name: 'invoice-create-for-student-no-enroll',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/invoice/create-for-student-has-no-enroll.vue')
  },
  {
    path: '/invoices/:id',
    name: 'invoice-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice/show.vue'),
  }
]
